import Input from '../../inputs/input';
import * as inputDefinitions from '../../../config/inputs';

const income = new Input(inputDefinitions.income);

income.validators = [
  (data) => {
    if (data.income > 10000000) {
      return {
        valid: false,
        message: 'Value must be less than $10,000,000',
      };
    }
    if (data.income <= 0) {
      return {
        valid: false,
        message: 'Please enter your income',
      };
    }
    return {
      valid: true,
      message: '',
    };
  },
];

const inputLibrary = {
  income,
};

export default inputLibrary;
